import React from 'react';
import moment from "moment";
import {PAGINATION} from "ubs-framework/v2/common/constant";
import {getLocal, setLocal} from "ubs-framework/v2/common/function";

export const startDate = new Date(moment().subtract(6, 'days').set({'hour': 0, 'minute': 0, 'second': 0}));
export const endDate = new Date(moment().set({'hour': 0, 'minute': 0, 'second': 0}));

const initialState = {
    socketId: '',
    _id: '',
    auditLogs: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        createdBy: null,
        createdAt: {
            startDate,
            endDate,
        }
    },
    addQuickCandidate: {
        flag: false,
        data: {}
    },
    candidateList: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        salary: {
            from: 0,
            to: 0,
        },
        location: null,
        job: null,
        jobTitle: null,
        tags: null,
        source: null,
        isRejected: null,
        stageManager: null,
        skills: null,
        stage: null,
        createdBy: null,
        candidateType: 'active',
        sortBy: getLocal('u_cl') ? getLocal('u_cl') : 'activity',
    },
    addQuickEvaluationModal: {
        flag: false,
        data: {}
    },
    addEvaluationModal: {
        flag: false,
        data: {}
    },
    giveEvaluationModal: null,
    addColumnOption: [],
    countryList: [],
    stateList: [],
    interviewList:[],
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'ADD_QUICK_CANDIDATE': {
            return {...state, addQuickCandidate: {...state.addQuickCandidate, ...action.payload}}
        }
        case 'ADD_QUICK_EVALUATION_CANDIDATE': {
            return {...state, addQuickEvaluationModal: {...state.addQuickEvaluationModal, ...action.payload}}
        }
        case 'ADD_EVALUATION_MODAL': {
            return {...state, addEvaluationModal: {...state.addEvaluationModal, ...action.payload}}
        }
        case 'GIVE_EVALUATION_MODAL': {
            return {...state, giveEvaluationModal: action.payload}
        }
        case 'FILTER_CANDIDATE_LIST': {
            if(action.payload.sortBy) setLocal('u_cl', action.payload.sortBy);
            return {...state, candidateList: {...state.candidateList, ...action.payload}}
        }
        case 'GET_CANDIDATE_OPTION': {
            return {...state, addColumnOption: action.payload}
        }
        case 'GET_INTERVIEW_LIST':{
            return {...state, interviewList: action.payload}
        }
        case 'SET_COUNTRY_STATE': {
            return {...state, ...(action.payload || {})}
        }

        default: {
            return state;
        }
    }
}
